export function validateVoucher({
  voucherType,
  partyLedgerId,
  counterLedgerId,
  voucherDate,
  dueDate,
  amount,
  mode,
  cheque,
  allocated,
  today,
}) {
  const errors = {};
  const money = voucherType === "RECEIPT" || voucherType === "PAYMENT";
  if (!partyLedgerId) errors.partyLedgerId = "Party is required";
  if (!voucherDate) errors.voucherDate = "Date is required";
  else if (today && voucherDate > today) errors.voucherDate = "Date cannot be in the future";
  if (!money) {
    if (!dueDate) errors.dueDate = "Due date is required";
    else if (voucherDate && dueDate < voucherDate) errors.dueDate = "Due date cannot be before the voucher date";
  }
  if (!counterLedgerId) {
    errors.counterLedgerId = money
      ? mode === "CASH" ? "Cash ledger is required" : "Bank ledger is required"
      : voucherType === "SALES" ? "Sales ledger is required" : "Purchase ledger is required";
  }
  const numeric = Number(amount);
  if (!amount || !Number.isFinite(numeric) || numeric <= 0) errors.amount = "Amount is required";
  if (money && mode === "CHEQUE") {
    if (!String(cheque.chequeNo || "").trim()) errors.chequeNo = "Cheque number is required";
    if (!cheque.chequeDate) errors.chequeDate = "Cheque date is required";
    if (voucherType === "RECEIPT" && !String(cheque.drawerBankName || "").trim()) {
      errors.drawerBankName = "Drawer bank is required";
    }
  }
  if (money && Number.isFinite(numeric) && allocated - numeric > 0.009) {
    errors.allocations = "Allocated amount cannot be more than the voucher amount";
  }
  return errors;
}

export function validateLedger(form) {
  const errors = {};
  if (!String(form.name || "").trim()) errors.name = "Name is required";
  if (!form.group) errors.group = "Group is required";
  const opening = Number(form.openingBalance || 0);
  if (!Number.isFinite(opening) || opening < 0) errors.openingBalance = "Opening balance cannot be negative";
  const email = String(form.contact?.email || "").trim();
  if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "Enter a valid email";
  if (form.group === "BANK") {
    if (!String(form.bankDetails?.accountNo || "").trim()) errors.accountNo = "Account number is required";
    if (!String(form.bankDetails?.ifsc || "").trim()) errors.ifsc = "IFSC is required";
    if (!String(form.bankDetails?.branch || "").trim()) errors.branch = "Branch is required";
  }
  return errors;
}
